export const TRACKING_PANEL_EDD_TEST_ID = 'TrackingPanelEDD';
export const TRACKING_PANEL_EDD_TEXT_TEST_ID = 'TrackingPanelEDDText';
